import React from "react";
import { Modal } from "antd";
import styled from "@emotion/styled";

const DetailImageModal = ({
  visible,
  img,
  topic,
  remark,
  onClose,
  imageWidth,
}) => {
  return (
    <StyledModal footer={null} visible={visible} onCancel={onClose}>
      <Image imageWidth={imageWidth} src={img} />
      <TopicConfirm>{topic}</TopicConfirm>
      <Remark>{remark}</Remark>
    </StyledModal>
  );
};

export default DetailImageModal;

const TopicConfirm = styled.h5`
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #058459;
  margin-bottom: 4px;
`;
const Remark = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #4b5768;
  margin-bottom: 16px;
  white-space: pre-line;
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;

    .ant-modal-body {
      padding: 36px 32px;
      text-align: center;
    }
  }
`;

const Image = styled.img`
  margin-bottom: 16px;
  width: 100%;
  max-width: ${(props) => (props.imageWidth ? props.imageWidth : "312")}px;

  margin-top: 14px;
`;
